import {TaxonomyBrief} from "@/service";

const expUnit = "[\\s\u4E00-\u9FA5A-Za-z']*";

export function searchTaxonomy(v: TaxonomyBrief, s: string, t = ""): boolean {
  const beingSearched = v.name + v.pinyin;
  const expMatch = new RegExp(expUnit + s.split('').join(expUnit) + expUnit);
  return expMatch.test(beingSearched);
}
